<template>
	<ContentBox :boxData="boxData" @button-click="onButtonClicked" />
</template>

<script>
import ContentBox from "./ContentBox";
import { ButtonEventsMixin } from "./mixins";

/**
 * The Content Box is a template that provides a heading, paragraph text, and CTA button within a styled box.
 *
 * ## `boxData` props
 *
 * The `boxData` object the accepts the following properties:
 *
 * - **boxID** {String} (optional) the ID for the content box
 *
 * - **fgColor** {String} (optional) the foreground color name (can be `white` or `almost-black`)
 *
 * - **bgColor** {String} background color variable name (refer to the @vg-faset/core color palette)
 *
 * - **bgPosition** {String|Object} (optional) enter 'right' or 'left', or define the bgPosition for each breakpoint in an object `{ sm: 'center bottom', md: 'left bottom', lg: 'left bottom' }`
 *
 * - **graphic** {String} graphic url
 *
 * - **bgSize** {Object} background size object for each breakpoint (sm/md/lg)
 *
 * - **bgOverlayColor** {String} (optional) color overlay (hexadecimal color value with hash, ex `#ffffff`). sits over the background image but behind the text content
 *
 * - **bgOverlayOpacity** {String} (optional) opacity value for the background color overlay (value range 0.0 to 1.0)
 *
 * - **title** {String} the `<h3>` title of the content box
 *
 * - **content** {String|Array} the `<p>` content of the content box. Pass an array to create multiple `<p>`
 *
 * - **contentMarginBottom** {Object} (optional) custom margin bottom for below the content paragraph element. Define the margin-bottom for each breakpoint in an object `{ sm: '80px', md: '80px', lg: '180px' }`
 *
 * - **maxWidth** {String|Object} (optional) set the max width of the content as a string `80%`, or as an object for each breakpoint `{ sm: '100%', md: '100%', lg: '80%' }`
 *
 * - **ctaUrl** {String} the href for the CTA button
 *
 * - **ctaText** {String} the text of the CTA button
 *
 * - **ctaDescription** {String} description of the CTA link functionality (for accessibility - read by screen readers)
 *
 * - **ctaLocked** {Boolean} whether to display the lock icon that denotes secure content
 *
 */
export default {
	name: "ContentBox1up",
	mixins: [ButtonEventsMixin],
	props: {
		/**
		 * An object containing properties to populate the content box. For available properties, refer to the documentation above.
		 */
		boxData: {
			type: Object,
			required: false
		}
	},
	components: { ContentBox }
};
</script>
